import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-featured-resource-card__hero" }
const _hoisted_3 = { class: "c-featured-resource-card__hero-copy" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "c-featured-resource-card__resource-bar" }
const _hoisted_6 = { class: "c-featured-resource-card__resource-heading" }
const _hoisted_7 = { class: "c-featured-resource-card__resource-count" }
const _hoisted_8 = { class: "c-featured-resource-card__list" }
const _hoisted_9 = { class: "c-featured-resource-card__item-content" }
const _hoisted_10 = { class: "c-featured-resource-card__type" }
const _hoisted_11 = { class: "c-featured-resource-card__item-title" }
const _hoisted_12 = {
  key: 0,
  class: "c-featured-resource-card__bullets"
}
const _hoisted_13 = ["aria-label"]

import { computed } from 'vue';
import {
  FeaturedResourceCardProps,
  FeaturedResourceCardResourceFields,
} from '@/types/components/FeaturedResourceCard';
import utils from '@/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'FeaturedResourceCard',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;

const fields = computed(() => props.fields);

const rootClass = computed(() =>
  utils.overall.baseComClass(props.fields, 'c-featured-resource-card')
);
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const resources = computed(() => fields.value?.resources || []);
const heroImage = computed(() => {
  const image = fields.value?.image as any;
  return Array.isArray(image) ? image[0] : image;
});
const resourceCountLabel = computed(() => {
  const count = resources.value.length;
  const suffix = fields.value?.resourceCountSuffix?.value || 'items';
  return `${count} ${count === 1 && suffix === 'items' ? 'item' : suffix}`;
});

const getResourceTitle = (resource: FeaturedResourceCardResourceFields) =>
  resource.title?.value || '';

const getLinkHref = (link: any) => link?.value?.href || link?.href || '#';

const getLinkAttrs = (link: any) => {
  const value = link?.value || link || {};
  const href = getLinkHref(link);
  const attrs: Record<string, string> = { href };

  if (value.target) attrs.target = value.target;
  if (value.title) attrs.title = value.title;
  if (value.target === '_blank') attrs.rel = 'noopener noreferrer';

  return attrs;
};

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_AdaptiveImage = _resolveComponent("AdaptiveImage")!
  const _component_JssText = _resolveComponent("JssText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: __props.rendering?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [1, 22],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (fields.value?.title?.value)
                  ? (_openBlock(), _createElementBlock("h2", {
                      key: 0,
                      innerHTML: fields.value?.title.value
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                _createVNode(_component_JssRichText, {
                  class: "c-featured-resource-card__description",
                  field: fields.value?.description
                }, null, 8, ["field"]),
                (fields.value?.link?.value?.href)
                  ? (_openBlock(), _createElementBlock("a", _mergeProps({
                      key: 1,
                      class: "c-featured-resource-card__link"
                    }, getLinkAttrs(fields.value?.link)), [
                      _createElementVNode("span", null, _toDisplayString(fields.value?.link?.value?.text || 'Learn More'), 1),
                      _cache[0] || (_cache[0] = _createElementVNode("span", {
                        class: "c-featured-resource-card__link-icon",
                        "aria-hidden": "true"
                      }, null, -1))
                    ], 16))
                  : _createCommentVNode("", true)
              ]),
              (heroImage.value?.fields?.desktopImage?.value?.src)
                ? (_openBlock(), _createBlock(_component_AdaptiveImage, {
                    key: 0,
                    class: "c-featured-resource-card__image",
                    field: heroImage.value,
                    "is-background": true,
                    "lazy-load": false,
                    "enable-scroll-detection": false,
                    show: true,
                    "show-image-redius": false
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", _hoisted_6, [
                _cache[1] || (_cache[1] = _createElementVNode("span", {
                  class: "c-featured-resource-card__book-icon",
                  "aria-hidden": "true"
                }, null, -1)),
                _createVNode(_component_JssText, {
                  field: fields.value?.resourceHeading
                }, null, 8, ["field"])
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(resourceCountLabel.value), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resources.value, (resource) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: resource.id || resource.name,
                  class: "c-featured-resource-card__item"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(resource.fields?.typeLabel?.value), 1),
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(resource.fields ? getResourceTitle(resource.fields) : ''), 1),
                    (resource.fields?.bullets?.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resource.fields.bullets, (bullet) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: bullet.id || bullet.name,
                              class: "c-featured-resource-card__bullet"
                            }, _toDisplayString(bullet.fields?.text?.value), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("a", _mergeProps({ class: "c-featured-resource-card__download" }, { ref_for: true }, resource.fields ? getLinkAttrs(resource.fields.downloadLink) : { href: '#' }, {
                    "aria-label": `Open ${resource.fields ? getResourceTitle(resource.fields) : 'resource'}`
                  }), [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "none",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", {
                        d: "M4.16699 10H15.8337",
                        "stroke-width": "1.66667",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        stroke: "white"
                      }),
                      _createElementVNode("path", {
                        d: "M10 4.16675L15.8333 10.0001L10 15.8334",
                        "stroke-width": "1.66667",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        stroke: "white"
                      })
                    ], -1)
                  ]))], 16, _hoisted_13)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})